export enum DateFormats {
    Date = 'YYYY-MM-DD',
    Program = 'MMM D YYYY',
    MonthYear = 'MMMM YYYY',
    MonthStart = 'YYYY-MM-01',
    ShortMonthAndYear = 'MMM YYYY'
}
